import { getServiceUrl } from '../utils/externalPages';

export const USEFUL_LINKS_ITEMS = [
  {
    label: 'swap',
    url: `${getServiceUrl()}/swaps`,
  },
  {
    label: 'k2p',
    url: `${getServiceUrl()}/k2p`,
  },
];
